import { fromJS, Record } from 'immutable';

export const sessionsRecord = new Record({
  active: fromJS({
    byId: fromJS({}),
    allIds: fromJS([])
  }),
  historical: fromJS({
    byId: fromJS({}),
    allIds: fromJS([]),
    pagination: fromJS({})
  })
});

export default sessionsRecord();
